import { useLayoutEffect, useState } from "react";
import { Container, Draggable, DropResult } from "react-smooth-dnd";
import arrayMove from 'array-move';
import { styled } from "@mui/system";
import { OrganizationOrderForm } from "../gateways/cms/organization";
import Color from "../styles/colors.js";

// style
const WrapperHead = styled("section")`
    position: relative;
    margin-left: 1px;
    margin-bottom: 1px;
`;
const TableHead = styled("table")`
    height: 32px;
    padding: 4px 0 4px 8px;
    background-color: ${Color.bgHead};
    text-align: left;
    font-weight: normal;
    margin: 0px 0px 2px 0px; 
    border: 1px solid ${Color.gray};
    border-collapse: collapse;

    tr > th {
        padding: 4px 0 4px 8px;
        font-weight: normal;
        border: 2px solid ${Color.gray};
        
        &.id {
            width: 91px;
        }
        &.name {
            width: 500px;
        }
        &.gyoshaId {
            width: 10em;
        }
        &.parent {
            width: 25em;
        }
        &.level {
            width: 4em;
        }
        &.updatedAt {
            width: 8em;
        }
        &.createdAt {
            width: 8em;
        }
    }
`;
const WrapperBody = styled("section")`
    position: relative;
    margin-bottom: 5px;
    overflow-y:auto;
`;
const TableBody = styled("table")`
    height: 32px;
    padding: 4px 0 4px 8px;
    background-color: #faffff;
    text-align: left;
    font-weight: normal;
    border-bottom-style: double;
    border-left-style: double;
    border-right-style: double;
    border-collapse: collapse;

    tr {
        border-top-style: double;
    }

    tr > td {
        border-right: 1px solid  #c0c0c0;
        padding: 4px 0 4px 8px;
        &.id {
            font-size: 18px;
            width: 90px;
        }
        &.name {
            font-size: 18px;
            width: 500px;
        }
        &.gyoshaId {
            width: 10em;
        }
        &.parent {
            width: 25em;
        }
        &.level {
            width: 4em;
        }
        &.updatedAt {
            width: 8em;
        }
        &.createdAt {
            width: 8em;
        }
    }
`;

export interface Props {
    organizations: OrganizationOrderForm[];
    organizationOrders: any;
}

export const OrganizationOrder = (props: Props) => {
    const organizations: OrganizationOrderForm[] = props.organizations;
    const organizationOrders = props.organizationOrders;
    useLayoutEffect(() => {
            if (organizations) {
                setOrganizationDatas(organizations);
            } else {
                setOrganizationDatas([]);
            }
        }, [organizations]);
    const [organizationDatas, setOrganizationDatas] =  useState(organizations);

    const handleDrop = ({ removedIndex, addedIndex }: DropResult) => {
        if (removedIndex === null || addedIndex === null) {
            return;
        }
        const newOrganizations = arrayMove(organizationDatas, removedIndex || 0, addedIndex || 0)
        setOrganizationDatas(newOrganizations);
        organizationOrders(newOrganizations);
    };

    return (
        <>
            <WrapperHead>
                <TableHead>
                    <tr>
                        <th className="id">
                            ID
                        </th>
                        <th className="name">
                            テナント名
                        </th>
                        <th className="gyoshaId">
                            業者コード
                        </th>
                        <th className="parent">
                            親組織
                        </th>
                        <th className="level">
                            階層
                        </th>
                        <th className="updatedAt">
                            更新日時
                        </th>
                        <th className="createdAt">
                            作成日時
                        </th>
                    </tr>
                </TableHead>
            </WrapperHead>
            <WrapperBody>
                <TableBody>
                    <Container lockAxis="y" onDrop={handleDrop}>
                        {organizationDatas.map((organization) => (
                            <Draggable key={organization.id}>
                                <tr>
                                    <td className="id">
                                        {organization.id}
                                    </td>
                                    <td className="name">
                                        {organization.name}
                                    </td>
                                    <td className="gyoshaId">
                                        {organization.gyoshaId}
                                    </td>
                                    <td className="parent">
                                        {organization.parent}
                                    </td>
                                    <td className="level">
                                        {organization.level}
                                    </td>
                                    <td className="updatedAt">
                                        {organization.updatedAt}
                                    </td>
                                    <td className="createdAt">
                                        {organization.createdAt}
                                    </td>
                                </tr>
                            </Draggable>
                        ))}
                    </Container>
                </TableBody>
            </WrapperBody>
        </>
    );
};
